import { combineReducers } from "redux";

import { reducer as formReducer } from "redux-form";

import app from "../app/reducer";
import entities from "../entities/reducer";
import auth from "../auth/reducer";
import offers from "../offers/reducer";
import applications from "../applications/reducer";

const configureReducer = initialState => {
  const reducer = combineReducers({
    form: formReducer,
    app,
    entities,
    auth,
    offers,
    applications
  });

  return reducer;
};

export default configureReducer;



// WEBPACK FOOTER //
// ./src/config/configureReducer.js